import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import _isEmpty from "lodash/isEmpty";
import _get from "lodash/get";
import _map from "lodash/map";
import clsx from "clsx";
import Fade from "react-reveal/Fade";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import toLocale from "../../helpers/toLocale";
import priceWithVAT from "../../helpers/priceWithVAT";
import SpaceBox from "../SpaceBox";
import PricingTableCard from "../ProductPriceTableCard";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import Slider from "./Slider";
import { SwiperSlide } from "swiper/react";
import { makeStyles } from "@material-ui/core/styles";
import { PAGES_SLUGS } from "../../constants";
import { Breadcrumb } from "../Breadcrumb";
import HeaderOfferObserver from "../HeaderOfferObserver";
import getSuppotedFileType from "../../helpers/getSuppotedFileType";
import Container from "@material-ui/core/Container";
import ReactHtmlParser from "react-html-parser";
import _size from "lodash/size";
import itemDetailsStyles from "../../theme/itemDetailsStyles";
import { getWishlistData, WL } from "../../helpers/localStorage";
import Icon from "@material-ui/core/Icon";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useDispatch, useSelector } from "react-redux";
import {
  addCarToWishlist,
  removeCarFromWishlist,
} from "../../containers/WishlistPage/actions";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import Chip from "@material-ui/core/Chip";
import { ECOBONUS_VALUE, ECOBONUS_BEV_VALUE } from "../../constants";
import { fieldSubscriptionItems } from "final-form";
import format from "date-fns/format";

const ProductHeroSlider = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { data } = props;
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [open, setOpen] = useState(false);
  const [openRemove, setOpenRemove] = useState(false);
  const updatingWishlist = useSelector((state) => state.wishlist.request);

  const archived = _get(data, "archived", false);
  const isUsedCar = _get(data, "car_type", "") === "UsedCar";
  const showEcoBonus = _get(data, "ecobonus", false) && !archived;
  const showElectricEcoBonus = _get(data, "ecobonus_bev", false) && !archived;

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
    setOpenRemove(false);
  };

  const addToWishlist = () => {
    setOpenRemove(false);
    dispatch(addCarToWishlist(data.slug));
    setOpen(true);
  };

  const removeFromWishlist = () => {
    setOpen(false);
    dispatch(removeCarFromWishlist(data.slug));
    setOpenRemove(true);
  };

  const renderEcobonus = () => {
    /**
     * ecoBonusData[0] is assigned to hybrid cars
     * ecoBonusData[1] is assigned to electric cars
     */
    const ecoBonusData = _get(
      props.pageData,
      "data.ecobonus_section.ecobonus_section",
      []
    );

    if (!_isEmpty(ecoBonusData[0]) && showEcoBonus) {
      return ReactHtmlParser(_get(ecoBonusData[0], "attributes.text", ""));
    }

    if (!_isEmpty(ecoBonusData[1]) && showElectricEcoBonus) {
      return ReactHtmlParser(_get(ecoBonusData[1], "attributes.text", ""));
    }

    return null;
  };
  const getEcobonus = () => {

    if (showEcoBonus || showElectricEcoBonus) {
      return _get(data, "price_data.ecobonus_value", 0);
    }

    return null;
  };



  const showDiscountPrice = +_get(data,'final_discount_percentage',0) > 0 ;

  return (
    <React.Fragment>
      <Snackbar
        open={open}
        onClose={handleClose}
        autoHideDuration={2000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        className={classes.customSnackbar}
      >
        <Alert
          onClose={handleClose}
          action={""}
          icon={false}
          className={`${classes.customAlert} ${classes.alertSuccess}`}
        >
          ✓ Adăugat cu succes in wish list
        </Alert>
      </Snackbar>
      <Snackbar
        open={openRemove}
        onClose={handleClose}
        autoHideDuration={2000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        className={classes.customSnackbar}
      >
        <Alert
          onClose={handleClose}
          action={""}
          icon={false}
          className={`${classes.customAlert} ${classes.alertSuccess}`}
        >
          <Icon className={clsx("brand-icon-remove")} /> Șters cu succes in wish
          list
        </Alert>
      </Snackbar>
      <Fade>
        <Grid container className={classes.root}>
          <Grid item md={7} xs={12} className={classes.darkGrey}>
            <Box
              height={"100%"}
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"space-between"}
              className={classes.swiperContainer}
            >
              <Box display={"block"} className={classes.white}>
                <Slider loop={true} effect="fade" contrast={true}>
                  {!_isEmpty(_get(data, "photos_exterior", [])) &&
                    _map(_get(data, "photos_exterior", []), (item, index) => {
                      return (
                        <SwiperSlide key={index}>
                          <div className={clsx(classes.slide)}>
                            <img
                              // Remove lazy load support due to browser POP bug
                              src={getSuppotedFileType(_get(item, "big", []))}
                              className={clsx(classes.image)}
                            />
                          </div>
                        </SwiperSlide>
                      );
                    })}
                </Slider>
              </Box>
              {/* <Box display={"block"} className={classes.thumbRoot}>
                                <Slider
                                    onSwiper={(slider) => {
                                        setThumbsSwiper(slider);
                                    }}
                                    spaceBetween={8}
                                    freeMode={true}
                                    slidesPerView={4}
                                    watchSlidesVisibility={true}
                                    watchSlidesProgress={true}
                                    breakpoints={{
                                        500: {
                                            spaceBetween: 16,
                                            slidesPerView: 5
                                        },
                                    }}
                                >
                                    {!_isEmpty(_get(data, "photos", [])) && _map(_get(data, "photos", []), (item, index) => {
                                        return <SwiperSlide key={index}>
                                            <div className={classes.thumbSlide}>
                                                <img src={getSuppotedFileType(_get(item, "thumb", []))}
                                                     className={clsx(classes.thumbImage)}/>
                                            </div>
                                        </SwiperSlide>
                                    })}

                                </Slider>
                            </Box> */}
            </Box>
          </Grid>

          <Grid item md={5} xs={12} className={classes.details}>
            {/*<Breadcrumb buttonName={"Modele"} name={_get(data, "model", "")} />*/}
            <div className={classes.tags}>
              {_get(data, "rezervat", false) && (
                <Chip className={classes.chipReserved} label="Rezervat" />
              )}
              {(_get(data, "ecobonus", false) ||
                _get(data, "ecobonus_bev", false)) && (
                  <Chip className={classes.chipEchoBonus} label="Eco Bonus" />
                )}
            </div>
            <div className={classes.headerContent}>
              {!isUsedCar && (
                <Typography className={classes.sku} component="p">
                  # {_get(data, "rom_ref", "")}
                </Typography>
              )}
              <Typography variant="h1" component="h1" className={classes.title}>
                {_get(data, "name", "")}
              </Typography>
              {/*<Hidden smDown>*/}

              {archived ? (
                <Typography component="div" className={`${classes.text}`} gutterBottom>
                  Ne pare rău! Mașină nu mai este disponibilă in oferta Volvo.
                </Typography>
              ) : (
                <Typography
                  component={"div"}
                  className={clsx(classes.rootPrice, classes.priceContainer)}
                >
                  <span className={classes.price}>
                    {toLocale(_get(data, "price_data.final_offer_price_with_vat", ""))}€{" "}  <span>TVA <br />inclus</span>
                  </span>
                  {showDiscountPrice && (
                    <div className={classes.oldPrice}>
                      Redus de la: <br />
                      <span className={classes.oldPriceLineThrough}>
                        {toLocale(_get(data, "price_data.total_price_with_vat", ""))}€  <span className={classes.tva}>TVA <br />inclus</span>
                      </span>{" "}
                    </div>
                  )}
                </Typography>
              )}
              <Box className={classes.buttonsContainer}>
                {!archived ? (
                  <Button
                    component={RouterLink}
                    variant="contained"
                    color="primary"
                    classes={{
                      root: `${classes.button} ${classes.buttonMargin}`,
                    }}
                    to={`/${PAGES_SLUGS.OFFERS}/${_get(data, "slug", "")}`}
                  >
                    Cere ofertă
                  </Button>
                ) : (
                  <Button
                    component={RouterLink}
                    variant="contained"
                    color="primary"
                    classes={{
                      root: `${classes.button} ${classes.buttonMargin}`,
                    }}
                    to={`/${PAGES_SLUGS.PRODUCTS}`}
                  >
                    Vezi modele similare
                  </Button>
                )}
                {!archived && (
                  <React.Fragment>
                    {getWishlistData(WL.CAR).includes(
                      _get(data, "slug", "")
                    ) ? (
                      <Button
                        variant="outlined"
                        size="large"
                        color="primary"
                        classes={{ root: classes.buttonOutlined }}
                        startIcon={<Icon className="brand-icon-heart-fill" />}
                        onClick={removeFromWishlist}
                        disabled={updatingWishlist}
                      >
                        Șterge din wish list
                        {updatingWishlist && (
                          <CircularProgress
                            size={24}
                            className={classes.buttonProgress}
                          />
                        )}
                      </Button>
                    ) : (
                      <Button
                        variant="outlined"
                        size="large"
                        color="primary"
                        classes={{ root: classes.buttonOutlined }}
                        startIcon={<Icon className="brand-icon-heart" />}
                        onClick={addToWishlist}
                        disabled={updatingWishlist}
                      >
                        Wish list
                        {updatingWishlist && (
                          <CircularProgress
                            size={24}
                            className={classes.buttonProgress}
                          />
                        )}
                      </Button>
                    )}
                  </React.Fragment>
                )}
              </Box>

              {!archived && !isUsedCar && (
                <Grid container>
                  <Grid item xs={12} className={classes.priceTable}>
                    <PricingTableCard
                      priceData={_get(data, "price_data", {})}
                      // recommendedPrice={_get(data, "total_car_price", "")}
                      // dealerBonus={_get(data, "total_client_advantage", "")}
                      // ourPrice={_get(data, "client_invoice_price", "")}
                      discountPercentage={_get(data, "final_discount_percentage", "")}
                      ecoBonus={getEcobonus()}

                    />
                  </Grid>
                </Grid>
              )}

              {!archived && isUsedCar && (
                <Grid container className={classes.usedCarAttributes}>
                  <Grid item xs={12}>
                    <Box className={classes.usedCarAttributesContainer}>
                      <Grid item xs={4} sm={4} className={classes.usedCarAttribute} container
                        direction="column"
                        alignItems="center">
                        <Typography variant={"subtitle1"} className={classes.usedCarAttributeLabel}>
                          Kilometraj:
                        </Typography>
                        <span className={"brand-icon-large brand-icon-speed"}></span>
                        <Typography variant={"h6"} align={"center"} className={classes.usedCarAttributeValue}>
                          {toLocale(data.km_purchase_date)}km
                        </Typography>
                      </Grid>
                      <Grid item xs={4} sm={4} className={classes.usedCarAttribute} container
                        direction="column"
                        alignItems="center">
                        <Typography variant={"subtitle1"} className={classes.usedCarAttributeLabel}>
                          Anul fabricației
                        </Typography>
                        <span className={"brand-icon-large brand-icon-factory"}></span>
                        <Typography variant={"h6"} align={"center"} className={classes.usedCarAttributeValue}>
                          {data.manufacturing_year}
                        </Typography>
                      </Grid>
                      <Grid item xs={4} sm={4} className={classes.usedCarAttribute} container
                        direction="column"
                        alignItems="center">
                        <Typography variant={"subtitle1"} align={"center"} className={classes.usedCarAttributeLabel}>
                          Data primei înmatriculări
                        </Typography>
                        <span className={"brand-icon-medium brand-icon-idcard"}></span>
                        <Typography variant={"h6"} align={"center"} className={classes.usedCarAttributeValue}>
                          {data.manufacturing_year}
                        </Typography>
                      </Grid>
                    </Box>
                  </Grid>
                </Grid>
              )}
            </div>
          </Grid>
        </Grid >
      </Fade >
      <HeaderOfferObserver
        className={`${classes.offerHeader}`}
        stickyClass={classes.showHeader}
      >
        <div className={classes.headerRoot}>
          <Container>
            <div className={classes.headerSizing}>
              <Box
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
                height={"100%"}
                className={classes.mobileHeaderWrapper}
              >
                <Typography className={classes.headerTitle}>
                  {_get(data, "name", "")}
                </Typography>
                <Box
                  display={"flex"}
                  alignItems={"center"}
                  className={classes.mobileTextWrapper}
                >
                  {!archived && (
                    <React.Fragment>
                      <Box
                        display={"flex"}
                        className={classes.mobilePricesWrapper}
                      >
                        <span
                          className={`${classes.stickyPrice} ${classes.headerPrice}`}
                        >

                          {toLocale(_get(data, "price_data.final_offer_price_with_vat", ""))}€  <span className={classes.tva}>TVA <br />inclus</span>

                        </span>
                        {showDiscountPrice && (
                          <div
                            className={`${classes.stickyOldPrice} ${classes.headerOldPrice}`}
                          >
                            Redus de la: <br />
                            <span className={classes.stickyOldPriceLineThrough}>

                              {toLocale(_get(data, "price_data.total_price_with_vat", ""))}€  <span className={classes.tva}>TVA <br />inclus</span>

                            </span>{" "}

                          </div>
                        )}
                      </Box>
                      <Button
                        component={RouterLink}
                        variant="contained"
                        color="primary"
                        classes={{
                          root: `${classes.button} ${classes.headerButton}`,
                        }}
                        to={`/${PAGES_SLUGS.OFFERS}/${_get(data, "slug", "")}`}
                      >
                        Cere ofertă
                      </Button>
                    </React.Fragment>
                  )}
                </Box>
              </Box>
            </div>
          </Container>
        </div>
      </HeaderOfferObserver>
    </React.Fragment >
  );
};

const offerHeaderTransition = 0.2;

const useStyles = makeStyles((theme) => ({
  ...itemDetailsStyles(theme),
  root: {
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingTop: theme.spacing(1),
  },

  darkGrey: {
    background: "#585859",
  },
  details: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  },

  white: {
    background: "#fff",
  },

  swiperContainer: {
    backgroundColor: "#fff",
  },

  swiperSlide: {
    backgroundColor: "#fff",
  },

  slide: {
    position: "relative",
    // paddingTop: "56.28%",
    paddingTop: "60%",
    width: "100%",

    borderRadius: theme.spacing(2),
    overflow: "hidden",
  },

  image: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  thumbRoot: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },

  thumbSlide: {
    width: "100%",
    paddingTop: "56.17%",
    position: "relative",
    cursor: "pointer",
  },

  thumbImage: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: "100%",
    height: "100%",
    opacity: 0.4,
    transition: theme.transitions.create(["opacity"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    ".swiper-slide-thumb-active &": {
      opacity: 1,
    },
  },
  header: {
    position: "relative",
  },
  tags: {
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(3),
    display: "flex",
    gap: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
  },
  headerContent: {
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(0),
    [theme.breakpoints.down("sm")]: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
  },

  chipReserved: {
    backgroundColor: "#F8D200",
  },
  chipEchoBonus: {
    backgroundColor: "#2BD921",
  },
  button: {
    backgroundColor: "#6198CF",
    marginRight: theme.spacing(3),
  },
  buttonOutlined: {
    marginBottom: theme.spacing(3),
  },
  buttonMargin: {
    marginBottom: theme.spacing(3),
  },
  buttonsContainer: {
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
    },
  },
  title: {
    letterSpacing: 0,
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(36),
    lineHeight: theme.typography.pxToRem(42),
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      fontSize: theme.typography.pxToRem(24),
      lineHeight: theme.typography.pxToRem(32),
    },
  },
  sku: {
    color: "#707070",
    fontSize: "14px",
    fontWeight: "300",
    letterSpacing: 0,
    lineHeight: "24px",
    paddingBottom: theme.spacing(0),
  },
  text: {
    letterSpacing: 0,
    fontWeight: theme.typography.fontWeightLight,
    fontSize: theme.typography.pxToRem(18),
    lineHeight: theme.typography.pxToRem(24),
    [theme.breakpoints.down("sm")]: {
      fontSize: theme.typography.pxToRem(16),
    },
    "&$bottomSpacing": {
      marginBottom: theme.spacing(2),
    },
  },
  bottomSpacing: {
    /*Empty declaration for nested declaration*/
  },
  rootPrice: {
    ...itemDetailsStyles(theme).rootPrice,
    paddingBottom: theme.spacing(3),
  },
  priceContainer: {
    display: "inline-flex",
    paddingTop: theme.spacing(0),
  },
  stickyPrice: {
    color: "#1C6BBA",
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.pxToRem(32),
    lineHeight: theme.typography.pxToRem(32),
    [theme.breakpoints.down("sm")]: {
      fontSize: theme.typography.pxToRem(24),
    },
    '& span': {
      display: 'inline-block',
      fontSize: theme.typography.pxToRem(13),
      lineHeight: '100%',
      letterSpacing: '0%',
      verticalAlign: 'middle',
      marginBottom: '5px',
    }
  },
  stickyOldPrice: {
    color: "#707070",
    fontSize: theme.typography.pxToRem(12),
    lineHeight: theme.typography.pxToRem(15),
    fontWeight: "300",
    paddingTop: theme.spacing(0),
    [theme.breakpoints.down("sm")]: {
      paddingTop: theme.spacing(0),
    },
  },
  stickyOldPriceLineThrough: {
    color: "#707070",
    fontSize: theme.typography.pxToRem(18),
    lineHeight: '100%',
    letterSpacing: '0%',
    verticalAlign: 'middle',
    display: 'flex',
    textDecoration: "line-through",
    '& span': {
      display: 'inline-block',
      marginLeft: '5px',
      fontSize: theme.typography.pxToRem(9),

      lineHeight: '100%',
      letterSpacing: '0%',
      verticalAlign: 'middle',
      textDecoration: 'line-through',
    }
  },
  price: {
    color: "#1C6BBA",
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.pxToRem(32),
    lineHeight: theme.typography.pxToRem(32),
    [theme.breakpoints.down("sm")]: {
      fontSize: theme.typography.pxToRem(28),
      lineHeight: theme.typography.pxToRem(28),
    },
    '& span': {
      display: 'inline-block',
      fontSize: theme.typography.pxToRem(13),
      lineHeight: '100%',
      letterSpacing: '0%',
      verticalAlign: 'middle',
      marginBottom: '7px',
    }
  },

  oldPrice: {
    color: "#707070",
    fontSize: theme.typography.pxToRem(12),
    lineHeight: theme.typography.pxToRem(15),
    fontWeight: "300",
    paddingLeft: "10px",
    paddingTop: theme.spacing(0),
    [theme.breakpoints.down("sm")]: {
      paddingTop: theme.spacing(0),
      lineHeight: theme.typography.pxToRem(14),
    },
  },

  oldPriceLineThrough: {
    color: "#707070",
    fontSize: theme.typography.pxToRem(18),
    lineHeight: '100%',
    letterSpacing: '0%',
    verticalAlign: 'middle',
    textDecoration: "line-through",
    display: 'flex',
    fontWeight: 'bold',
    alignItems: 'center',

    [theme.breakpoints.down("sm")]: {
      lineHeight: theme.typography.pxToRem(14),
    },
    '& span': {
      display: 'inline-block',
      marginLeft: '5px',
      fontSize: theme.typography.pxToRem(9),

      lineHeight: '100%',
      letterSpacing: '0%',
      verticalAlign: 'middle',
      textDecoration: 'line-through',
    }
  },
  headerRoot: {
    background: `#fafafa`,
  },
  headerSizing: {
    height: 100,
  },
  offerHeader: {
    zIndex: 1101,
    top: 0,
    opacity: 0,
    visibility: `hidden`,
    width: `100%`,
    position: `fixed`,
    transition: `opacity ${offerHeaderTransition}s 0s, visibility 0s ${offerHeaderTransition}s`,
  },
  showHeader: {
    opacity: 1,
    visibility: `visible`,
    transition: `opacity ${offerHeaderTransition}s, visibility ${offerHeaderTransition}s 0s`,
  },
  headerTitle: {
    fontSize: `1.125rem`,
    fontWeight: 500,
    lineHeight: `1.5rem`,
    overflow: `hidden`,
    textOverflow: `ellipsis`,
    display: `-webkit-box`,
    lineClamp: 3,
    boxOrient: `vertical`,
    [theme.breakpoints.down("sm")]: {
      marginRight: theme.spacing(0),
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(20),
    },
  },
  headerPrice: {
    textAlign: `center`,
    marginRight: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      textAlign: "left",
      marginRight: theme.spacing(0),
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(20),
    },
  },
  headerOldPrice: {
    marginRight: theme.spacing(5),
    padding: 0,
    [theme.breakpoints.down("sm")]: {
      marginRight: theme.spacing(2),
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(20),
    },
    "@media (max-width: 460px)": {
      // display: `none`
    },
  },
  headerButtonText: {},
  headerButton: {
    textAlign: `center`,
    fontSize: theme.typography.pxToRem(14),
    [theme.breakpoints.down("sm")]: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(20),
      padding: theme.spacing(1),
    },
  },

  mobileHeaderWrapper: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      flexDirection: `column`,
      justifyContent: `space-evenly`,
      alignItems: `flex-start`,
      paddingLeft: theme.spacing(0),
      paddingRight: theme.spacing(0),
    },
  },
  mobileTextWrapper: {
    [theme.breakpoints.down("sm")]: {
      alignItems: `center`,
      alignSelf: `stretch`,
      justifyContent: `space-between`,
    },
  },
  mobilePricesWrapper: {
    [theme.breakpoints.down("sm")]: {
      flexDirection: `column`,
    },
  },
  priceTable: {
    [theme.breakpoints.up("md")]: {
      maxWidth: 480
    },
  },
  usedCarAttributes: {
    maxWidth: "360px",
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      maxWidth: "100%"
    },
  },
  usedCarAttributesContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#f5f5f5",
    borderRadius: theme.spacing(1),
    padding: theme.spacing(2, 2),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2, 1),
    },
  },
  usedCarAttribute: {
    flex: "1 0 30%",

    [theme.breakpoints.down("sm")]: {
      flex: "1 0 33%",
      minWidth: "150px",
      marginBottom: 0,
      paddingBottom: 0,
      borderBottom: "none",
    },
  },
  usedCarAttributeLabel: {
    color: "#000000",
    fontSize: theme.typography.pxToRem(11),
    fontWeight: 700,
    lineHeight: "100%",
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      fontSize: theme.typography.pxToRem(12), // Smaller font for mobile
      height: theme.spacing(4), // Fixed height to align all labels
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },
  usedCarAttributeValue: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 400,
    marginTop: theme.spacing(1),
    color: "#666",
    [theme.breakpoints.down("sm")]: {
      fontSize: theme.typography.pxToRem(14), // Smaller font for mobile
    },
  },

}));

export default ProductHeroSlider;
